function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".glob_fontElementMap,.lAu3C{font-family:var(--ricos-font-family,unset)}.DAP0T{color:var(--ricos-custom-link-color,var(--ricos-action-color,#0261ff));font-family:var(--ricos-custom-link-font-family,unset);font-size:var(--ricos-custom-link-font-size,unset);font-style:var(--ricos-custom-link-font-style,unset);font-weight:var(--ricos-custom-link-font-weight,unset);line-height:var(--ricos-custom-link-line-height,unset);min-height:var(--ricos-custom-link-min-height,unset);text-decoration:var(--ricos-custom-link-text-decoration,none)}@media only screen and (max-width:640px){[data-query=media] .DAP0T{font-size:var(--ricos-custom-link-font-size,unset)}}@supports not (contain:inline-size){@media only screen and (max-width:640px){[data-query=container] .DAP0T{font-size:var(--ricos-custom-link-font-size,unset)}}}@container (width < 640px){[data-query=container] .DAP0T{font-size:var(--ricos-custom-link-font-size,unset)}}[dir] .-uWd5:hover{cursor:text}[dir] .CATC8:hover{cursor:pointer}.M1CWN{display:flex}[dir=ltr] .M1CWN{margin-right:5px}[dir=rtl] .M1CWN{margin-left:5px}.Xvx9J{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#0261ff));max-width:270px;overflow:hidden;text-decoration:none;text-overflow:ellipsis;white-space:nowrap}.Xvx9J:hover{text-decoration:underline}[dir] .QX61w:hover{cursor:pointer}@media only screen and (max-width:640px){[data-query=media] .Xvx9J{max-width:160px}}@supports not (contain:inline-size){@media only screen and (max-width:640px){[data-query=container] .Xvx9J{max-width:160px}}}@container (width < 640px){[data-query=container] .Xvx9J{max-width:160px}}";
var styles = {"fontElementMap":"lAu3C","link":"DAP0T","linkInEditor":"-uWd5","linkInViewer":"CATC8","toolbarUrlContainer":"M1CWN","toolbarUrl":"Xvx9J","toolbarUrlAnchor":"QX61w"};
styleInject(css_248z);

export { styles as s };
//# sourceMappingURL=link-viewer-1109f86f.js.map
